import { MessageBubble } from "./message-bubble"
import { MessageActions } from "./message-actions"

interface MessageAttachment {
  name: string
  type: string
  size: number
  url?: string
}

interface Message {
  id: string
  type: "user" | "agent"
  content: string
  timestamp: Date
  attachments?: MessageAttachment[]
  toolCall?: string
  isStreaming?: boolean
  citations?: Array<{ node_id: number; name?: string | null }>
}

interface ChatThreadProps {
  messages: Message[]
  isLoading?: boolean
  onRegenerate: (messageId: string) => void
  onDocumentOpen?: (path: string) => void
}

export function ChatThread({ messages, isLoading, onRegenerate, onDocumentOpen }: ChatThreadProps) {
  if (messages.length === 0 && !isLoading) {
    return (
      <div className="h-full flex items-center justify-center px-4">
        <p style={{ color: "var(--hexa-text-muted)", fontSize: "13px" }}>Nessun messaggio</p>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-3 py-2">
      {messages.map((message) => {
        const isError = typeof message.id === "string" && (message.id.includes("timeout") || message.id.includes("-err"))
        return (
          <MessageActions
            key={message.id}
            messageId={message.id}
            content={message.content}
            type={message.type}
            isStreaming={message.isStreaming}
            isError={isError}
            onRegenerate={onRegenerate}
          >
            <MessageBubble
              type={message.type}
              content={message.content}
              timestamp={message.timestamp}
              attachments={message.attachments}
              toolCall={message.toolCall}
              isStreaming={message.isStreaming}
              citations={message.citations}
              onDocumentOpen={onDocumentOpen}
            />
          </MessageActions>
        )
      })}

      {/* Typing indicator */}
      {isLoading && <TypingIndicator />}
    </div>
  )
}

function TypingIndicator() {
  return (
    <div
      className="flex items-center gap-1"
      style={{
        alignSelf: "flex-start",
        backgroundColor: "var(--hexa-surface-hover)",
        borderRadius: "14px 14px 14px 4px",
        padding: "10px 16px",
      }}
    >
      <span
        className="inline-block rounded-full animate-pulse"
        style={{ width: 6, height: 6, backgroundColor: "var(--hexa-text-muted)", opacity: 0.6, animationDelay: "0ms" }}
      />
      <span
        className="inline-block rounded-full animate-pulse"
        style={{ width: 6, height: 6, backgroundColor: "var(--hexa-text-muted)", opacity: 0.4, animationDelay: "150ms" }}
      />
      <span
        className="inline-block rounded-full animate-pulse"
        style={{ width: 6, height: 6, backgroundColor: "var(--hexa-text-muted)", opacity: 0.25, animationDelay: "300ms" }}
      />
    </div>
  )
}
